import { Directive } from '@angular/core';
import { QtySelectComponentDef } from '@df/ui/form/qty-select.component.def';

/**
 * Qty Select Component.
 * Use for creating new quantity select components with the same logic and
 * custom template.
 */
@Directive()
export class QtySelectAbstract extends QtySelectComponentDef {}
